import { RegionShared } from "@1games-ru/region-shared";
import { useEffect } from "react";
import { Soundtrack } from "@/shared/sounds";
import SoundCore from "@/shared/widgets/SoundCore";
import { AdditionalFlow } from "@/domains/auth/constants/additionalFlow";
import useGetSocialClub from "@/domains/auth/hooks/useGetSocialClub";
import AuthCreatePinContainer from "@/domains/auth/containers/AuthCreatePinContainer";
import AuthNavigationContainer from "@/domains/auth/containers/AuthNavigationContainer";
import { AuthFlowProvider, useAuthFlow } from "@/domains/auth/containers/context";
import AuthResetPasswordContainer from "@/domains/auth/containers/reset-password/AuthResetPasswordContainer";
import AuthResetPinContainer from "@/domains/auth/containers/reset-pin/AuthResetPinContainer";
import AuthResetTfaAuthenticatorContainer from "@/domains/auth/containers/reset-tfa/AuthResetTfaAuthenticatorContainer";
import AuthResetTfaEmailContainer from "@/domains/auth/containers/reset-tfa/AuthResetTfaEmailContainer";
import AuthResetTfaSMSContainer from "@/domains/auth/containers/reset-tfa/AuthResetTfaSMSContainer";
import AuthSignInContainer from "@/domains/auth/containers/sign-in/AuthSignInContainer";
import AuthSignInPinContainer from "@/domains/auth/containers/sign-in/AuthSignInPinContainer";
import AuthSignInTfaContainer from "@/domains/auth/containers/sign-in/AuthSignInTfaContainer";
import AuthSignUpContainer from "@/domains/auth/containers/sign-up/AuthSignUpContainer";
import AuthUpdatePasswordContainer from "@/domains/auth/containers/update/AuthUpdatePasswordContainer";
import AuthUpdatePinContainer from "@/domains/auth/containers/update/AuthUpdatePinContainer";
import AuthLayout from "@/domains/auth/components/AuthLayout.tsx";

function Auth() {
  const { isAnyOpen, state } = useAuthFlow();
  const { getSocialClub } = useGetSocialClub();

  useEffect(() => {
    getSocialClub();
  }, [getSocialClub]);

  if (!isAnyOpen) return null;

  return (
    <AuthLayout>
      {state[RegionShared.Cef.Events.Auth.AuthSignIn2FAShow] && <AuthSignInTfaContainer />}
      {state[RegionShared.Cef.Events.Auth.AuthSignInPinShow] && <AuthSignInPinContainer />}
      {state[RegionShared.Cef.Events.Auth.AuthSignInShow] && <AuthSignInContainer />}
      {state[RegionShared.Cef.Events.Auth.AuthSignUpShow] && <AuthSignUpContainer />}
      {state[RegionShared.Cef.Events.Auth.AuthCreatePinShow] && <AuthCreatePinContainer />}
      {state[AdditionalFlow.AuthResetPassword] && <AuthResetPasswordContainer />}{" "}
      {/* /reset-password */}
      {state[AdditionalFlow.AuthUpdatePassword] && <AuthUpdatePasswordContainer />}{" "}
      {/* /reset-password/update */}
      {state[AdditionalFlow.AuthResetPin] && <AuthResetPinContainer />} {/* /reset-pin */}
      {state[AdditionalFlow.AuthUpdatePin] && <AuthUpdatePinContainer />} {/* /reset-pin/update */}
      {state[AdditionalFlow.AuthResetTfaEmail] && <AuthResetTfaEmailContainer />}{" "}
      {/* /reset-tfa/email */}
      {state[AdditionalFlow.AuthResetTfaSMS] && <AuthResetTfaSMSContainer />} {/* /reset-tfa/sms */}
      {state[AdditionalFlow.AuthResetTfaAuthenticator] && (
        <AuthResetTfaAuthenticatorContainer />
      )}{" "}
      {/* /reset-tfa/google */}
      <AuthNavigationContainer />
      <SoundCore trigger="mount" name={Soundtrack.AccountBackground} />
    </AuthLayout>
  );
}

export default function AuthContainer() {
  return (
    <AuthFlowProvider>
      <Auth />
    </AuthFlowProvider>
  );
}
